import React, {Component} from 'react';
import { Row, Col } from 'antd';
import Lightbox from 'react-images';

/**
 * thumb: single image to show
 * images: [] images in grid
 * gallery: [] gallery images with [{src:''},{src:''}] format
 * opt: {
 *   itemClass: apply to Col
 * }
 */
class ImageGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen:false,
      current: 0
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.gotoPrev = this.gotoPrev.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
  }
/*
  componentDidMount() {
    const {opt} = this.props;
    this.setState({isOpen: (opt.hideGrid)?true:false});
  }
*/
  gotoNext(){
    const {gallery} = this.props;
    let current = this.state.current;
    let c = (current < gallery.length)?current+1:current;
    this.setState({current: c});
  }
  gotoPrev(){
//    const {images} = this.props;
    let current = this.state.current;
    let c = (current > 0)?current-1:0;
    this.setState({current: c});
  }
  handleClose(){
    this.setState({isOpen:false});
  }
  handleOpen(idx){
//    console.info(idx);
    this.setState({
      isOpen:true,
      current:idx
    });
  }

  render(){
    const {images, gallery, thumb, opt} = this.props;

    return(
      <div>
        {images &&
        <Row gutter={10}>
          {images.map((image, idx) => (
            <Col key={idx}
                 xs={8}
                 className={opt.itemClass ? opt.itemClass : null}>
              <img
                src={image}
                alt=""
                className='rounded'
                onClick={() => this.handleOpen(idx)}
                style={{width: '100%'}}
              />
            </Col>
          ))}
        </Row>
        }

        {thumb &&
        <div>
          <img
            src={thumb}
            onClick={() => this.handleOpen(0)}
            style={{width: '100%'}}
          />
        </div>
        }

        {gallery &&
        <Lightbox
          images={gallery}
          isOpen={this.state.isOpen}
          currentImage={this.state.current}
          onClickPrev={this.gotoPrev}
          onClickNext={this.gotoNext}
          onClose={this.handleClose}
        />
        }
      </div>
    )
  }
}

export default ImageGrid;


// WEBPACK FOOTER //
// ./src/components/ImageGrid.js